import { Link } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  usePageMeta(
    "页面不存在 - 91视频免费看",
    "抱歉，你访问的页面不存在或已被移除。返回首页继续浏览 91视频免费看的电影与电视剧资源。"
  );

  return (
    <div className="w-full max-w-[1400px] mx-auto px-4 md:px-8 py-20 md:py-28">
      <div className="flex flex-col items-center justify-center text-center">
        <p className="font-heading text-7xl md:text-9xl font-bold text-primary-500">404</p>
        <h1 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">页面不存在</h1>
        <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg leading-relaxed">
          抱歉，你访问的页面可能已被移除、重命名，或是输入的网址有误。
          你可以返回首页，或继续浏览电影与电视剧频道。
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-white text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-home-line"></i>
            返回首页
          </Link>
          <Link
            to="/movie"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-100 border border-background-200 text-foreground-700 text-sm font-medium hover:bg-background-200 transition-colors whitespace-nowrap"
          >
            <i className="ri-film-line"></i>
            浏览电影
          </Link>
          <Link
            to="/tv"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-100 border border-background-200 text-foreground-700 text-sm font-medium hover:bg-background-200 transition-colors whitespace-nowrap"
          >
            <i className="ri-tv-2-line"></i>
            浏览电视剧
          </Link>
        </div>
      </div>
    </div>
  );
}